// extracted by mini-css-extract-plugin
export default {"linkField":"ActivityFieldInfo-styles__linkField___lSWbn","html":"ActivityFieldInfo-styles__html___sCvb3"};